import React from "react";
import "./style.scss";

const Input = (props) => {
  return (
    <div className="website_input">
      <span>http://</span>
      <input {...props} />
    </div>
  );
};
export default Input;
